import {match} from 'ts-pattern';

import {DepositFormValues} from '../schemas/depositSchema';

// Switched-off configuration is deliberately wiped server-side instead of being resent — a
// disabled method is collapsed to {isAllowed: false} and disallowing deposits clears everything.
// The document series keeps its canonical `documentSeriesId` name; an API that spells it
// differently renames it in its own module.
export function buildDepositPatchBody(deposit: DepositFormValues) {
  return match(deposit.allowDeposit)
    .with(false, () => ({
      allowDeposit: false,
      templateId: null,
      documentSeriesId: null,
      defaultPaymentType: null,
      cashPayment: {isAllowed: false},
      cardPayment: {isAllowed: false},
      bankPayment: {isAllowed: false},
    }))
    .with(true, () => ({
      allowDeposit: true,
      templateId: deposit.templateId,
      documentSeriesId: deposit.documentSeriesId,
      defaultPaymentType: deposit.defaultPaymentType,
      cashPayment: deposit.cashPayment.isAllowed ? deposit.cashPayment : {isAllowed: false},
      cardPayment: deposit.cardPayment.isAllowed ? deposit.cardPayment : {isAllowed: false},
      bankPayment: deposit.bankPayment.isAllowed ? deposit.bankPayment : {isAllowed: false},
    }))
    .exhaustive();
}
